import { render, staticRenderFns } from "./ModalConfigPrograms.vue?vue&type=template&id=246b776b&scoped=true"
import script from "./ModalConfigPrograms.vue?vue&type=script&lang=js"
export * from "./ModalConfigPrograms.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigPrograms.vue?vue&type=style&index=0&id=246b776b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b776b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246b776b')) {
      api.createRecord('246b776b', component.options)
    } else {
      api.reload('246b776b', component.options)
    }
    module.hot.accept("./ModalConfigPrograms.vue?vue&type=template&id=246b776b&scoped=true", function () {
      api.rerender('246b776b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/BussinessAndBranch/ModalConfigPrograms.vue"
export default component.exports